/*
 * Returns the scrollTop of the window.
 */
const scrollTop = (): number =>
  document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop || 0;
export default scrollTop;
